import { ValueGetterParams } from "ag-grid-community";

export const timestampColumnFilter = {
    filter: "agDateColumnFilter",
    filterParams: {
        buttons: ["reset"]
    },
    filterValueGetter: filterValueGetter
};

function filterValueGetter(params: ValueGetterParams) {
    const value = params.getValue(params.colDef.field!);
    return typeof value === "string"
        ? new Date(value)
        : value;
}